import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TuiButton, TuiScrollbar } from '@taiga-ui/core';
import { ActionsModule } from '@src/app/modules/actions';
import { ComponentsModule } from '@src/app/components';

import { ChatModule } from '../../chat';

import { BaseChatsListComponent } from './base-chats-list.component';

@NgModule({
  declarations: [BaseChatsListComponent],
  imports: [CommonModule, ActionsModule, TuiButton, TuiScrollbar, ComponentsModule, ChatModule],
  exports: [BaseChatsListComponent],
})
export class BaseChatsListModule {}
